import PropTypes from 'prop-types';

const Spinner = ({ className, small }) => {
    const classes = ['spinner', className];

    if (small) {
        classes.push('small');
    }

    return (
        <div className={classes.join(' ')} />
    );
};

Spinner.propTypes = {
    className: PropTypes.string,
    small: PropTypes.bool,
};

export default Spinner;
